import * as React from 'react';
import '../css/action-popup.sass';
import Popup from './Popup';
import ActionButtons, { ActionButton } from './ActionButtons';

interface ActionPopupProps {
  headingText: string;
  message: React.ReactNode;
  buttons: ActionButton[];
  onPopupClose?: Function;
}

export default function ActionPopup(props: ActionPopupProps) {
  return (
    <>
      <Popup
        modal
        displayCloseButton
        className="actionpopup"
        position="center"
        onClose={props.onPopupClose}
      >
        <div className="actioncontent">
          <h1 className="title">{props.headingText}</h1>
          <div className="description">{props.message}</div>
          <ActionButtons buttons={props.buttons} />
        </div>
      </Popup>
    </>
  );
}
